import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";
import { Observable } from "rxjs";
import {
  IMeetingRoomKioskBookingCreationData,
  IMeetingRoomKioskData,
  IMeetingRoomKioskEventDetailsData,
} from "../models/kiosk.model";

@Injectable({
  providedIn: "root",
})
export class MeetingRoomsKioskService {
  private readonly http = inject(HttpClient);

  loadKioskMode(roomId: string): Observable<IMeetingRoomKioskData> {
    return this.http.get<IMeetingRoomKioskData>(
      `/v1/kiosk/meetingRooms/${roomId}?wholeDay=true`,
    );
  }

  loadEventDetails({
    roomId,
    eventId,
  }: {
    roomId: string;
    eventId: string;
  }): Observable<IMeetingRoomKioskEventDetailsData> {
    return this.http.get<IMeetingRoomKioskEventDetailsData>(
      `/v1/kiosk/meetingRooms/${roomId}/events/${eventId}`,
    );
  }

  createBooking({
    roomId,
    data,
  }: {
    roomId: string;
    data: IMeetingRoomKioskBookingCreationData;
  }): Observable<{ booking: string }> {
    return this.http.post<{ booking: string }>(
      `/v1/kiosk/meetingRooms/${roomId}/bookings`,
      data,
    );
  }

  checkInBooking({
    roomId,
    eventId,
  }: {
    roomId: string;
    eventId: string;
  }): Observable<{ booking: string }> {
    return this.http.post<{ booking: string }>(
      `/v1/kiosk/meetingRooms/${roomId}/events/${eventId}/checkIn`,
      {},
    );
  }

  finishBooking({
    roomId,
    eventId,
    endTime,
  }: {
    roomId: string;
    eventId: string;
    endTime: string;
  }): Observable<{ booking: string }> {
    return this.http.patch<{ booking: string }>(
      `/v1/kiosk/meetingRooms/${roomId}/events/${eventId}`,
      { endTime },
    );
  }

  exitKioskMode(roomId: string): Observable<void> {
    return this.http.post<void>(`/v1/kiosk/meetingRooms/${roomId}/exit`, {});
  }
}
